import { render, staticRenderFns } from "./carteira-ativos.vue?vue&type=template&id=717f349a&"
import script from "./carteira-ativos.vue?vue&type=script&lang=js&"
export * from "./carteira-ativos.vue?vue&type=script&lang=js&"
import style0 from "./carteira-ativos.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCheckbox,VChip,VIcon,VProgressLinear})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717f349a')) {
      api.createRecord('717f349a', component.options)
    } else {
      api.reload('717f349a', component.options)
    }
    module.hot.accept("./carteira-ativos.vue?vue&type=template&id=717f349a&", function () {
      api.rerender('717f349a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/carteira-ativos/carteira-ativos.vue"
export default component.exports